// Drag payload for the dispatch board.
// The browser drop has to work even when React has not re-rendered yet,
// so the payload is kept on a ref and copied onto dataTransfer.

const scheduleSnap = require('./utils/scheduleSnap');

function payloadFromJob(job) {
  const source = job || {};
  const jobId = source.job_id || source.id;
  return {
    job_id: jobId,
    schedule_id: source.schedule_id || null,
    duration_hours: scheduleSnap.blockDurationHours(source),
    customer_name: source.company_name || source.customer_name || null,
    site_name: source.site_name || null,
    job_number: source.job_number || null,
    job_status: source.job_status || null,
    job_category: source.job_category || source.job_type || null,
    label: source.job_number || `#${jobId}`,
  };
}

function writePayload(event, payload) {
  const transfer = event && event.dataTransfer;
  if (!transfer) return;
  transfer.effectAllowed = 'move';
  try {
    transfer.setData('application/json', JSON.stringify(payload));
    transfer.setData('text/plain', payload.label || '');
  } catch (_err) {
    // Some synthetic drag events reject setData. The ref still holds the payload.
  }
}

function readPayload(event, ref) {
  if (ref && ref.current && ref.current.job_id) return ref.current;
  const transfer = event && event.dataTransfer;
  if (!transfer || typeof transfer.getData !== 'function') return null;
  try {
    const raw = transfer.getData('application/json');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.job_id === undefined || parsed.job_id === null) return null;
    return parsed;
  } catch (_err) {
    return null;
  }
}

module.exports = {
  payloadFromJob,
  readPayload,
  writePayload,
};
